// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--SJrQT","center":"center--SJrQT","desktopImg":"desktopImg--SJrQT","intro":"intro--SJrQT"};